import { render } from "./SplitRowAll.vue?vue&type=template&id=6abb5203&scoped=true"
import script from "./SplitRowAll.vue?vue&type=script&lang=js"
export * from "./SplitRowAll.vue?vue&type=script&lang=js"

import "./SplitRowAll.vue?vue&type=style&index=0&id=6abb5203&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6abb5203"]])

export default __exports__